import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Frame.scss";
import NextButton from './nextButton.js';
import Frame0 from "./img/frame_01white.png";
import Frame1 from "./img/frame_02blue.png";
import Frame2 from "./img/frame_03green.png";
import Frame3 from "./img/frame_04red.png";
import Frame4 from "./img/frame_05yellow.png";
import AppContext from './AppContext';

export default function Frame(props) {

    const myContext = useContext(AppContext);
    const navigate = useNavigate();

    const frames = [Frame0, Frame1, Frame2, Frame3, Frame4];
    const frameNames = ["White", "Blue", "Green", "Red", "Yellow"];
    const frameColors = ["#ffffff", "#1E88FD", "#00AB49", "#FE2B27", "#FFB900"];

    const handleNext = () => {
        myContext.imageSelected4[0] = frames[myContext.FValue];
        navigate("/Export");
    }

    return (
        <div className="FrameDiv">
            <h1 className="title">프레임을 선택하세요.</h1>
            
            <div className="frameMainContent">
                <div className="framePreviewLarge">
                    <div className="previewContainer">
                        <img src={frames[myContext.FValue]} className="previewFrame" alt="Selected Frame"/>
                        <div className="previewPhotos">
                            <img src={myContext.imageSelected4[1]} className="prevPhoto" alt="" style={{ visibility: myContext.imageSelected4[1] ? 'visible' : 'hidden' }}/>
                            <img src={myContext.imageSelected4[2]} className="prevPhoto" alt="" style={{ visibility: myContext.imageSelected4[2] ? 'visible' : 'hidden' }}/>
                            <img src={myContext.imageSelected4[3]} className="prevPhoto" alt="" style={{ visibility: myContext.imageSelected4[3] ? 'visible' : 'hidden' }}/>
                            <img src={myContext.imageSelected4[4]} className="prevPhoto" alt="" style={{ visibility: myContext.imageSelected4[4] ? 'visible' : 'hidden' }}/>
                        </div>
                    </div>
                </div>

                <div className="frameSelectionBottom">
                    <div className="colorButtons">
                        {frameNames.map((name, index) => (
                            <div 
                                key={index}
                                className={`colorOption ${myContext.FValue === index ? 'selected' : ''}`}
                                onClick={() => myContext.setFrame(index)}
                            >
                                <div className="colorCircle" style={{ backgroundColor: frameColors[index] }}></div>
                                <span className="colorName">{name}</span>
                            </div>
                        ))}
                        <div className="nextBtnWrapper" onClick={handleNext}>
                            <NextButton />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
